import React from 'react'
import Footer from '../UIElements/Footer'
import nsbhl from '../../../images/nsbhl.PNG'
import che from '../../../images/coolHockey_logo.png'
import futureStars from '../../../images/futureStars2025_logo.jpg'
import rivals from '../../../images/rivals.jpg'
import murrysville from '../../../images/Sportzone_logo.png'
import pennhills from '../../../images/pennHills_logo.jpg'
import cranberry from '../../../images/cranberry_logo.jpg'
import newken from '../../../images/Memorial_Park_Logo.JPG'
import sloths from '../../../images/Sloths_Logo_Circle.png'
import pabha from '../../../images/pabhaLogoOriginal.png'
import badgers from '../../../images/Badgers_Logo.png'
import badgersLapiana from '../../../images/Badgers_Logo2.PNG'
import clubs from '../../../images/clubsKnapper_transparent.png'
import teamPitt from '../../../images/teamPitt_logo.png'
import gtha from '../../../images/gtha_logo.PNG'

const customers = [
	{
		name: 'National Scholastic Ball Hockey League',
		image: nsbhl,
		link: 'https://nsbhlstats.com/schedule',
	},
	{
		name: 'Murrysville SportZone',
		image: murrysville,
		link: 'https://mvsportzone.web.app/schedule',
	},
	{
		name: 'Team Pitt Ball Hockey',
		image: teamPitt,
		link: 'https://teampgh-statsandstandings.web.app/schedule',
	},
	{
		name: 'GTHA',
		image: gtha,
		link: 'https://gtha-statsandstandings.web.app/schedule',
	},
	{
		name: 'USA Ball Hockey Future Stars Invitational',
		image: futureStars,
		// link: 'https://usabh-futurestars.web.app/schedule',
		link: 'https://usabh-futurestars.firebaseapp.com/schedule',
	},
	{
		name: 'Cool Hockey Events',
		image: che,
		link: 'https://coolhockeytournaments.web.app/schedule',
	},
	{
		name: 'USABH Clubs Championships',
		image: clubs,
		link: 'https://usabh-clubs.web.app/schedule',
	},
	{
		name: 'Rivals Championship Series',
		image: rivals,
		link: 'https://rivalschampionship.com/',
	},
	{
		name: 'Greater Pittsburgh Dek Hockey',
		image: pennhills,
		link: 'https://greaterpittdekhockey.web.app/',
	},
	{
		name: 'Cranberry Screaming Eagles',
		image: cranberry,
		link: 'https://www.eaglesdekhockey.com/',
	},
	{
		name: 'Memorial Park Dek Hockey',
		image: newken,
		link: 'https://memorialparkdekhockey.web.app/',
	},
	{
		name: 'South Jersey Sloths',
		image: sloths,
		link: 'https://southjerseysloths.web.app/',
	},
	{
		name: 'Allegheny Badgers',
		image: badgers,
		link: 'https://allegheny-badgers.web.app/statsandstandings',
	},
	{
		name: 'PA Ball Hockey Association',
		image: pabha,
		link: 'https://www.pabha.org/',
	},
	{
		name: 'Badgers - Lapiana 2014',
		image: badgersLapiana,
		link: 'https://ahabadgerslapiana.web.app/',
	},
]

const styles = {
	page: {
		backgroundColor: '#3f434a',
		minHeight: '100vh',
		width: '100%',
		padding: '24px 16px 0px 16px',
		boxSizing: 'border-box',
	},
	container: {
		width: '100%',
		maxWidth: '1200px',
		margin: '0 auto',
	},
	welcomeSection: {
		textAlign: 'center',
		padding: '8px 8px 30px 8px',
	},
	title: {
		color: '#edcb37',
		fontSize: 'clamp(2.1rem, 5vw, 3.4rem)',
		fontWeight: 800,
		lineHeight: 1.08,
		margin: '0 0 18px 0',
		textShadow: '2px 2px 0 rgba(0,0,0,0.45)',
	},
	text: {
		color: '#f2f2f2',
		fontSize: 'clamp(1.05rem, 2.5vw, 1.45rem)',
		lineHeight: 1.65,
		maxWidth: '900px',
		margin: '0 auto',
	},
	grid: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gap: '16px',
	},
	card: {
		backgroundColor: '#f2f2f2',
		borderRadius: '16px',
		overflow: 'hidden',
		boxShadow: '0 6px 14px rgba(0,0,0,0.25)',
		display: 'flex',
		flexDirection: 'column',
		height: '210px',
	},
	imageWrap: {
		backgroundColor: '#ffffff',
		height: '90px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '12px',
	},
	image: {
		maxWidth: '100%',
		maxHeight: '70px',
		objectFit: 'contain',
	},
	cardBody: {
		padding: '8px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		textAlign: 'center',
		flex: 1,
	},
	cardTitle: {
		color: '#111111',
		fontSize: '0.85rem', // 👈 smaller
		fontWeight: 500,
		lineHeight: 1.1,
		textDecoration: 'none',
		marginBottom: '3px',
		height: '36px', // 👈 fixed height keeps cards even
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		padding: '0 4px',
	},
	button: {
		display: 'inline-block',
		backgroundColor: '#edcb37',
		color: '#3f434a',
		textDecoration: 'none',
		fontSize: '0.8rem',
		fontWeight: 700,
		padding: '6px 10px',
		borderRadius: '8px',
		border: '2px solid #edcb37',
		boxShadow: '0 3px 6px rgba(0,0,0,0.25)',
		transition: 'transform 0.1s ease, box-shadow 0.1s ease',
		// boxShadow:
		// 	'inset 0 1px 0 rgba(255,255,255,0.28), 0 2px 4px rgba(0,0,0,0.2)',
		marginTop: '2px',
	},
	footerWrap: {
		marginTop: '32px',
		marginLeft: '-16px',
		marginRight: '-16px',
		marginBottom: '0',
	},
}

const ListOfCustomers = () => {
	return (
		<div style={styles.page}>
			<div style={styles.container}>
				{/* <section style={styles.welcomeSection}>
					<h2 style={styles.title}>Welcome to Shirey Tournament Tracker</h2>
					<p style={styles.text}>
						Use the dropdown above to select your league or tournament, or
						explore one of our partner organizations below to view stats,
						schedules, and team information.
					</p>
				</section> */}

				<div style={styles.grid}>
					{customers.map((customer) => (
						<div key={customer.name} style={styles.card}>
							{/* IMAGE (not clickable) */}
							<div style={styles.imageWrap}>
								<img
									src={customer.image}
									alt={customer.name}
									style={styles.image}
								/>
							</div>

							{/* BODY */}
							<div style={styles.cardBody}>
								{/* TITLE (not clickable) */}
								<div style={styles.cardTitle}>{customer.name}</div>

								{/* BUTTON (ONLY clickable element) */}
								<a
									href={customer.link}
									target='_blank'
									rel='noreferrer'
									style={styles.button}
								>
									View Site
								</a>
							</div>
						</div>
					))}
				</div>

				<div style={styles.footerWrap}>
					<Footer />
				</div>
			</div>
		</div>
	)
}

export default ListOfCustomers
